import { FC } from 'react';
import { observer } from 'mobx-react';
import AppLayout from "modules/owners/containers/Single/components/Layout";
import ownerStore from 'stores/owner';
import Files from 'submodules/files/containers/index';


const OwnerFiles: FC = observer(() => {
  const owner: any = ownerStore.selected;

  return (
    <AppLayout>
      <Files resource_type='Owner' resource={owner} />
    </AppLayout>
  );
})

export default OwnerFiles;
